import { render, staticRenderFns } from "./XmPublicTable.vue?vue&type=template&id=531ecb6e&scoped=true"
import script from "./XmPublicTable.vue?vue&type=script&lang=js"
export * from "./XmPublicTable.vue?vue&type=script&lang=js"
import style0 from "./XmPublicTable.vue?vue&type=style&index=0&id=531ecb6e&prod&lang=scss&scoped=true"
import style1 from "./XmPublicTable.vue?vue&type=style&index=1&id=531ecb6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ecb6e",
  null
  
)

export default component.exports